export default {
    pageTitle: {
        appointments: 'Import de rendez-vous',
        campaigns: 'Import de contacts',
        contacts: 'Import de contacts',
    },
    list: {
        noImports: 'Aucun imports.',
        actions: 'Actions',
    },
    steps: {
        uploadTitle: 'Téléversement d\'un fichier',
        uploadDescription: 'Téléversez un fichier CSV ou XLSX.',
        matchTitle: 'Association des colonnes',
        matchDescription: 'Associez les colonnes à leur attribut respectif.',
        previewTitle: 'Aperçu',
        previewDescription: 'Aperçu du résultat avant l\'importation.',
    },
    confirmLeavingModal: {
        header: 'Voulez-vous vraiment quitter la page?',
        message: 'Si vous quitter la page maintenant, le processus d\'importation ne sera pas complété.',
    },
    upload: {
        allowedFileType: 'Types de fichiers autorisés : {types}.',
        dropFile: 'Déposez ou cliquez.',
        invalidFileType: 'Type de fichier invalide.',
        removeFile: 'Supprimer',
        viewFile: 'Aperçu',
        upload: 'Téléverser',
        validateNumbers: 'Valider les numéros de téléphone cellulaire',
        validateNumbersTooltip: 'Activez cette option pour vous assurer que les numéros sont des cellulaires valides',
        uploadError: 'Erreur serveur. Veuillez vérifier que le fichier est valide.',
    },
    columnMatching: {
        appointmentNotes: 'Notes (rendez-vous)',
        belongsTo: 'Correspond à...',
        btnPreview: 'Aperçu',
        columnName: 'Nom de la colonne:',
        communicationPreference: 'Préférence de communication',
        contactNotes: 'Notes (contact)',
        date: 'Date',
        datetime: 'Date & heure',
        email: 'Courriel',
        firstName: 'Prénom',
        fullName: 'Nom complet',
        lastName: 'Nom',
        locale: 'Langue',
        name: 'Nom',
        new: 'Nouvel attribut',
        phone: 'Téléphone',
        none: 'Passer',
        time: 'Heure',
        unsubscribed: 'Désabonné',
    },
    preview: {
        appointmentNotes: 'Notes (rendez-vous)',
        btnImport: 'Importer',
        communicationPreference: 'Préférence de comm.',
        communicationPreferences: {
            sms: 'SMS',
            phone: 'Téléphone',
            email: 'Courriel',
        },
        contactNotes: 'Notes (contact)',
        date: 'Date',
        email: 'Courriel',
        firstHundredOnly: 'Seulement les 100 premières rangées sont affichées ci-dessus.',
        importModal: {
            header: 'Prêt à importer?',
            message: 'Avez-vous validé toutes les données dans l\'aperçu?',
        },
        invalidData: 'Données requises manquantes ou invalides',
        invalidDate: 'Date invalide',
        missingOptionalData: 'Données facultatives manquantes',
        missingRequiredDate: 'Données requises manquantes',
        moreColumns: '... et {number} autre | ... et {number} autres',
        name: 'Nom',
        phone: 'Téléphone',
        status: 'Statut',
        successMessage: 'Importation en cours...',
    },
    result: {
        import: 'Import',
        status: 'Statut',
        types: {
            appointment: 'Rendez-vous',
            contact: 'Contacts',
            campaign: 'Campagne',
        },
    },
};
